<template>
  <div>
    <!-- 活动模块 -->
    <div class="activity" v-if="officialActData.length">
      <div class="activity-tab" v-if="officialActData.length > 1">
        <van-tabs v-model="activeOfficialAct" type="card" :ellipsis="false">
          <van-tab
            :title="item.actName"
            v-for="(item, index) in officialActData"
            :key="index"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="activity-main">
        <div v-for="(item, index) in activeActList" :key="index">
          <!--商品actType 0，优惠券 1-->
          <div class="activity-item" v-if="commodityInfo.actType === 0">
            <div class="activity-item-commodity">
              {{ item.productLabel }}
            </div>
            <div class="activity-item-title">
              <div class="activity-item-country">
                <img :src="item.countryImg" alt="" />
              </div>
              <div class="activity-item-name">{{ item.productName }}</div>
            </div>
            <div class="activity-item-price">
              <div class="activity-item-new">
                <b>￥</b>{{ toFixed(item.preferentialPrice) }}
                <span>{{ item.priceUnit || "" }}</span>
              </div>
              <div class="activity-item-old">
                ￥{{ toFixed(item.originalPrice) }}
              </div>
            </div>
            <div
              class="activity-item-label"
              v-if="commodityInfo.discountsIsShow === 1"
            >
              立省{{ toFixed(item.originalPrice - item.preferentialPrice) }}元
            </div>
            <div
              class="activity-item-bought"
              v-if="commodityInfo.buyIsShow === 1"
            >
              <div class="activity-item-progress">
                <div :style="{ width: `${item.consumptionRate}%` }"></div>
              </div>
              <div class="activity-item-robbed">
                已抢{{ item.consumptionRate }}%
              </div>
            </div>
            <div
              class="activity-item-count"
              v-if="commodityInfo.timeIsShow === 1"
            >
              <div class="activity-item-count-title">热卖倒计时：</div>
              <countDown
                v-model="modelValue"
                :end-date="item.expirationTime"
                @end="endTime(item)"
              />
            </div>
            <van-button
              type="primary"
              class="activity-item-buy"
              @click="toBuy(item)"
              >立即购买
            </van-button>
          </div>
          <!--优惠券-->
          <div class="activity-item discount-item" v-else>
            <div class="activity-item-commodity">{{ item.voucherName }}</div>
            <div class="discount-item-box">
              <div class="discount-item-title flex">
                <div class="discount-item-type discount-item-type2" v-if="getCouponPriceIcon(item.discountType)">{{getCouponPriceIcon(item.discountType)}}</div>
                <div class="discount-item-num">
                  {{
                    getDiscountTenthsType(item.discountType)
                      ? getDiscountTenths(item.voucherMoney)
                      : item.voucherMoney
                  }}
                </div>
                <div class="discount-item-type discount-item-type2" v-if="getCouponSuffixText(item.discountType)">
                  {{ getCouponSuffixText(item.discountType) }}
                </div>
                <div class="discount-item-type">
                  {{ voucherType(item.centerDTO) }}
                </div>
              </div>
              <div class="discount-item-desc">
                {{ item.voucherCondition }}
              </div>
            </div>
            <div class="discount-item-rule">
              <div>领取时间：{{ item.receiveTime }}</div>
              <div>{{ item.applyProduct }}</div>
            </div>

            <div
              class="activity-item-bought"
              v-if="commodityInfo.buyIsShow === 1"
            >
              <div class="activity-item-progress">
                <div :style="{ width: `${item.consumptionRate}%` }"></div>
              </div>
              <div class="activity-item-robbed">
                已抢{{ item.consumptionRate }}%
              </div>
            </div>
            <div
              class="activity-item-count"
              v-if="commodityInfo.timeIsShow == 1"
            >
              <div class="activity-item-count-title">热卖倒计时：</div>
              <countDown
                v-model="modelValue"
                :end-date="item.expirationTime"
                @end="endTime(item)"
              />
            </div>

            <van-button
              type="primary"
              class="activity-item-buy"
              @click="receiveAward(item)"
              >立即领取
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { throttle, getCookie, debounce } from '@/util/util'
import { getCurrentAct } from '@/api/land.js'
import { wakeWechat } from '@/util/common'
import moment from 'moment'
import countDown from '@/components/countDown'
import {
  getDiscountTenthsType,
  getDiscountTenths,
  getCouponSuffixText,
  getCouponPriceIcon
} from '@ost/static/lib/common/coupon'

export default {
  components: { countDown },
  data () {
    return {
      moment,
      // 活动模块
      activeOfficialAct: 0,
      officialAct: [],
      modelValue: ''
    }
  },
  computed: {
    officialActData () {
      return this.officialAct.filter(v => {
        const child = this.filterInfoList(v)
        return child.length > 0
      })
    },
    activeActList () {
      const list = this.filterInfoList(this.commodityInfo)
      return [...(list || [])].sort((a, b) => {
        return a.sort - b.sort
      })
    },
    commodityInfo () {
      return this.officialActData[this.activeOfficialAct]
    }
  },
  created () {
    this.getCurrentAct()
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {},
  watch: {
    officialActData (val, oldVal) {
      if (val.length !== oldVal.length) {
        this.activeOfficialAct = 0
      }
    }
  },
  methods: {
    getDiscountTenthsType,
    getDiscountTenths,
    getCouponSuffixText,
    getCouponPriceIcon,
    filterInfoList (commodityInfo) {
      const { infoList = [], timeIsShow } = commodityInfo || {}
      const dateType = 'YYYY-MM-DD HH:mm:ss'
      const list = timeIsShow
        ? infoList.filter(v => {
          const isAfter = moment(this.modelValue, dateType).isAfter(
            moment(v.expirationTime, dateType)
          )
          return !isAfter
        })
        : infoList
      return list
    },
    // 活动模块
    getCurrentAct () {
      getCurrentAct().then(res => {
        if (res.code == 0) {
          const { officialAct: activity } = res.data || {}
          const list = activity || []
          const officialAct = list.sort((a, b) => a.sort - b.sort)
          this.officialAct = officialAct
          this.modelValue = moment(res.nowDate).format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.$message.error(res.msg)
        }
      })
      setInterval(this.schedule, 1000)
    },
    schedule () {
      const modelValue = moment(this.modelValue).valueOf() + 1000
      this.modelValue = moment(modelValue).format('YYYY-MM-DD HH:mm:ss')
      // console.log(this.modelValue, "this.modelValue");
    },
    toBuy (item) {
      wakeWechat.call(this, item.h5Url, item.pcUrl)
    },
    voucherType (data) {
      const { fullReductionType } = data || {}
      const text2 =
        fullReductionType == 0 || fullReductionType == 1 ? '满减券' : '优惠券'
      return text2
    },
    voucherDesc (data) {
      const {
        orderMoneySill,
        fullReductionType,
        userNumberRestrict,
        isFirstOrderUse
      } = data || {}
      // eslint-disable-next-line eqeqeq
      const text =
        (data &&
          (orderMoneySill > 0
            ? `${fullReductionType == 1 ? '每' : ''}满${orderMoneySill}可减`
            : '无门槛')) ||
        ''
      // eslint-disable-next-line eqeqeq
      const text2 =
        userNumberRestrict == 1 || fullReductionType == 1
          ? '可叠加'
          : '不可叠加'
      // eslint-disable-next-line eqeqeq
      const text3 = (isFirstOrderUse == 1 && '限首单使用') || ''
      return text + text2 + text3
    },
    getTime (data) {
      const { activityStartTime, activityEndTime } = data || {}
      const format = val => {
        return (val && moment(val).format('YYYY-MM-DD')) || ''
      }
      return `${format(activityStartTime)}-${format(activityEndTime)}`
    },
    showDiscounts (item) {
      const { centerDTO } = item
      const { isShowReceived, receiveWay } = centerDTO || {}
      // eslint-disable-next-line eqeqeq
      return isShowReceived == 1 && receiveWay == 1
    },
    percentage ({ receivedCount, issueCount } = {}) {
      const num = parseFloat(receivedCount || 0)
      const total = parseFloat(issueCount || 0)
      return Math.min(100, Math.max(0, Math.round((num / total) * 100))) || 0
    },
    toFixed (val = '', num = 2) {
      return val.toFixed(2)
    },
    receiveAward (item) {
      // wakeWechat.call(this,'2313','31313')
      wakeWechat.call(this, item.h5Url, item.pcUrl)
      // wakeWechat('minePages/pages/couponCenter/index', `${process.env.VUE_APP_MDT_USER_URL}/couponCenter`)
    },
    endTime (item) {
      // this.$nextTick(() => {
      //   this.activeActList.splice(
      //     this.activeActList.findIndex((v) => v.id === item.id),
      //     1
      //   )
      // })
    }
  }
}
</script>

<style lang="less" scoped>
.activity {
  background: #f7f8fa;
  text-align: left;

  ::v-deep .van-tabs--card > .van-tabs__wrap {
    height: 0.9rem;
  }

  ::v-deep .van-tabs__nav--card {
    margin: 0;
    height: 0.9rem;
    border: none;

    .van-tab.van-tab--active {
      background: #1363f7;
      color: #fff;
    }

    .van-tab {
      border: none;
    }

    .van-tab--active {
      padding: 0 0.34rem;
    }

    .van-tab {
      color: #69727a;
      font-size: 0.32rem;
    }
  }

  &-main {
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    padding: 0.32rem 0 0.32rem 0.32rem;
  }

  &-item {
    background: #fff;
    margin-right: 0.32rem;
    min-width: 5.2rem;
    padding: 0.52rem 0.32rem 1.32rem;
    line-height: 0.4rem;
    border-radius: 0.1rem;
    position: relative;
    min-height: 0.52rem;
    overflow: hidden;

    &-commodity {
      background-image: linear-gradient(to right, #e77b73, #ca453f);
      position: absolute;
      right: 0;
      top: 0;
      font-size: 0.24rem;
      font-weight: 600;
      color: #fff;
      min-width: 1.6rem;
      text-align: center;
      line-height: 0.5rem;
      height: 0.5rem;
      padding: 0 0.2rem 0 0.4rem;
      border-bottom-left-radius: 1rem;
    }

    &-title {
      display: flex;
      font-size: 0.12rem;
      font-weight: 500;
      color: #242933;
      align-items: center;
    }

    &-country {
      width: 0.44rem;
      height: 0.44rem;
      margin-right: 0.2rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &-name {
      font-size: 0.32rem;
    }

    &-price {
      display: flex;
      align-items: center;
      padding: 0.16rem 0;
    }

    &-new {
      font-size: 0.32rem;
      font-weight: 600;
      color: #ca453f;

      & > * {
        font-size: 0.24rem;
      }
    }

    &-old {
      font-size: 0.24rem;
      font-weight: 400;
      color: #a7a9ad;
      text-decoration: line-through;
      margin-left: 0.2rem;
    }

    &-label {
      border-radius: 0.06rem;
      border: 0.02rem solid #ca453f; // ignored
      display: inline-block;
      padding: 0 0.12rem;
      font-size: 0.24rem;
      color: #ca453f;
    }

    &-bought {
      display: flex;
      font-size: 0.2rem;
      font-weight: 500;
      color: #69727a;
      line-height: 0.28rem;
      align-items: center;
      padding: 0.28rem 0;
    }

    &-progress {
      margin-right: 0.2rem;
      height: 0.12rem;
      background: #d8ecff;
      border-radius: 0.06rem;
      flex: 1;
      position: relative;
      overflow: hidden;

      & > div {
        position: absolute;
        background: #1363f7;
        left: 0;
        border-radius: 0.06rem;
        height: 100%;
        width: 0;
      }
    }

    &-count {
      font-size: 0.28rem;
      font-weight: 400;
      color: #242933;
      display: flex;
      align-items: center;
      line-height: 0.36rem;
    }

    &-buy {
      height: 0.68rem;
      background: #1363f7;
      border-radius: 1rem;
      position: absolute;
      left: 0.32rem;
      right: 0.32rem;
      bottom: 0.32rem;
      border: none;
    }
  }
}

//优惠券
.discount-item {
  &-box {
    border-bottom: 0.02rem dashed #e7e7e7;
    padding-bottom: 0.2rem;
    line-height: 0;
  }

  &-title {
    font-size: 0.32rem;
    font-weight: 500;
    color: #ca453f;
    line-height: 0.44rem;
  }

  &-unit {
    font-size: 0.24rem;
  }

  &-num {
    font-size: 0.44rem;
    font-weight: 600;
    color: #ca453f;
  }

  &-type2 {
    margin: 0 0.2rem 0 0.08rem;
  }

  &-desc {
    font-size: 0.24rem;
    font-weight: 400;
    color: #ca453f;
    height: 0.36rem;
    line-height: 0.36rem;
    border-radius: 0.06rem;
    border: 0.02rem solid #ca453f;
    display: inline-block;
    padding: 0 0.08rem;
    margin-top: 0.16rem;
  }

  &-rule {
    font-size: 0.22rem;
    margin-top: 0.2rem;
    background: linear-gradient(270deg, #fff8f3 0%, #fee8ed 100%);
    border-radius: 0.1rem;
    padding: 0.16rem 0.2rem;
    font-weight: 400;
    color: #ca453f;
    line-height: 0.4rem;
  }
}

.flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/activityConfiguration.vue